import { useDesign } from "../state/designStore";
import { rgbFloatsToHex } from "../lib/color";
import { ColorOut } from "../types";
import { ColorPickerRow } from "./ColorPickerRow";
import { SliderControl } from "./SliderControl";

const CURVE_PRESETS = [
  { v: -60, label: "قوس للأسفل" },
  { v: 0, label: "مستقيم" },
  { v: 60, label: "قوس للأعلى" },
];

/** part: "gradient" = التدرّج اللوني، "curve" = النص المنحني، "all" = الاثنين.
 *  بدون زر تفعيل: اختيار لون التدرّج يفعّله مباشرة، وسلايدر الانحناء يطبّق فوراً (0 = مستقيم). */
export function EffectsControl({ colorPresets, part = "all" }: { colorPresets: ColorOut[]; part?: "all" | "gradient" | "curve" }) {
  const { activeText, updateActiveText } = useDesign();
  if (!activeText) return null;

  const gradientOn = !!activeText.gradient_color;
  const baseHex = activeText.text_color ?? (colorPresets[0] ? rgbFloatsToHex(colorPresets[0].rgb) : "#ffffff");
  const curve = activeText.curve_amount;

  return (
    <div className="flex flex-col gap-6">
      {part !== "curve" && (
        <div className="flex flex-col gap-4">
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="text-sm text-tg-hint">معاينة التدرّج</label>
              <span className="text-[11px] text-tg-hint">{gradientOn ? "مطبّق على النص" : "اختر اللون الثاني للتطبيق"}</span>
            </div>
            <div
              className="h-9 rounded-xl border border-white/15"
              style={{
                background: `linear-gradient(to left, ${baseHex}, ${activeText.gradient_color ?? baseHex})`,
                opacity: gradientOn ? 1 : 0.55,
              }}
            />
          </div>
          <ColorPickerRow
            label="اللون الثاني للتدرّج"
            value={activeText.gradient_color}
            presets={colorPresets}
            onChange={(hex) => updateActiveText({ gradient_color: hex })}
            onClear={() => updateActiveText({ gradient_color: null })}
          />
        </div>
      )}

      {part !== "gradient" && (
        <div className="flex flex-col gap-4">
          <SliderControl
            label="الانحناء"
            value={curve}
            min={-100}
            max={100}
            onChange={(v) => updateActiveText({ curve_amount: v })}
            unit=""
          />
          <div className="grid grid-cols-3 gap-2">
            {CURVE_PRESETS.map((c) => (
              <button
                key={c.v}
                type="button"
                onClick={() => updateActiveText({ curve_amount: c.v })}
                className={`py-2.5 rounded-xl text-xs font-medium ${
                  curve === c.v ? "bg-tg-button text-tg-buttonText" : "bg-white/10"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
          <p className="text-xs text-tg-hint">
            حرّك السلايدر وشوف النتيجة مباشرة. الصفر = نص مستقيم.
          </p>
        </div>
      )}
    </div>
  );
}
